export default {
	title: "",
	subtitle: "Subscription Statuses",
  path: "subscription_statuses",
  paragraph: '',
  request: {},
  domainsProperties: [
    {
      name: "pending",
      values: "It means that the subscription has been created but is still being processed"
    },
    {
      name: "active",
      values: "It means that the subscription has already been successfully processed, and the next invoice is already scheduled"
    },
    {
      name: "canceled",
      values: "It means that the subscription has been terminated, either because all charge attempts failed, because the partner requested the cancellation, or because the customer/subject chose to cancel. This is a final status"
    },
    {
      name: "completed",
      values: "It means that all cycles have been successfully paid and the subscription has ended. This is a final status"
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionStatus.js